import { css } from 'styled-components';

export const cyberGlassTextPrimary = '#d1d5db';
export const cyberGlassTextMuted = 'rgba(156, 163, 175, 0.86)';
export const cyberGlassHairline = 'rgba(148, 163, 184, 0.42)';

export const cyberGlassGradient = `linear-gradient(
  180deg,
  rgba(18, 18, 20, 0.58) 0%,
  rgba(24, 24, 28, 0.48) 44%,
  rgba(10, 10, 12, 0.62) 100%
)`;

export const cyberGlassBackdrop = css`
  background: rgba(3, 4, 6, 0.66);
  backdrop-filter: blur(3px) saturate(120%);
  -webkit-backdrop-filter: blur(3px) saturate(120%);
`;

export const cyberGlassSurface = css`
  background:
    radial-gradient(120% 90% at 12% 10%, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0) 48%),
    radial-gradient(100% 80% at 90% 100%, rgba(148, 163, 184, 0.08) 0%, rgba(148, 163, 184, 0) 54%),
    ${cyberGlassGradient};
  border: 1px solid ${cyberGlassHairline};
  box-shadow:
    0 14px 34px rgba(0, 0, 0, 0.32),
    inset 0 1px 0 rgba(255, 255, 255, 0.18),
    inset 0 -1px 0 rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(22px) saturate(140%) contrast(108%);
  -webkit-backdrop-filter: blur(22px) saturate(140%) contrast(108%);
  overflow: hidden;

  @supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
    background: linear-gradient(
      180deg,
      rgba(18, 18, 20, 0.88) 0%,
      rgba(24, 24, 28, 0.84) 44%,
      rgba(10, 10, 12, 0.9) 100%
    );
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background:
      radial-gradient(120% 70% at 0% 0%, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 58%),
      radial-gradient(100% 65% at 100% 100%, rgba(148, 163, 184, 0.12) 0%, rgba(148, 163, 184, 0) 58%);
    mix-blend-mode: normal;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background-image: linear-gradient(115deg, rgba(255, 255, 255, 0.11), rgba(255, 255, 255, 0) 35%);
    opacity: 0.35;
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;
